import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import * as PageQL from "queries/page";
import * as Notify from "@repoflow/form-schema/notify";
import { CancellableContent } from "@repoflow/components/content-cancel";
import { Mutation, Button } from "@repoflow/components/section";

export const Sidebar = () => null;

export const Indice = () => (
  <>
    <BreadcrumbItem>Remove</BreadcrumbItem>
  </>
);

export const Content = ({
  history,
  match: {
    params,
    params: { pageId },
  },
}) => {
  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            Removing the page <b>{pageId}</b>? This action will be permanent and
            can't be undone
          </Col>
        </Row>
        <Mutation
          mutation={PageQL.remove}
          update={PageQL.update(params)}
          onMutate={({ handler }) => {
            handler({
              variables: {
                pageId
              },
            });
          }}
          onCompleted={() => {
            history.replace(`/page`);
          }}
          onError={(error) => {
            Notify.error(error.toString());
          }}
        >
          {MutationHandler}
        </Mutation>
      </Container>
    </CancellableContent>
  );
};

const MutationHandler = ({ mutate }) => {
  return (
    <Row>
      <Col>
        <Button
          onClick={() => {
            mutate();
          }}
        >
          Remove
        </Button>
      </Col>
    </Row>
  );
};
